// @flow

import React, { type Node } from 'react';
import { type Country } from '@tectonics/prs/country';
import { isLocalLatamTenantCode } from '@tectonics/commons/tenant';
import { useControllerContext } from '@tectonics/controller/context';
import { useOpenedIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import { Link } from '../../../atoms';

export function FieldAcceptTerms(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const country = getCountry(incomingPayment);

  return (
    <div>
      <TextContent country={country} />
    </div>
  );
}

function TextContent(props: { country: Country }): Node {
  switch (props.country) {
    case 'br':
      return <TextContentForBrazil />;
    case 'mx':
      return <>Al continuar usted estará aceptando los <Link href="https://www.ebanx.com/mx/condiciones" target="_blank">términos de uso</Link> de EBANX.</>;
    case 'co':
      return <TextContentForColombia/>;
    case 'cl':
      return <>Al continuar usted estará aceptando los <Link href="https://www.ebanx.com/cl/condiciones" target="_blank">términos de uso</Link> de EBANX.</>;
    default:
      throw new Error(`Country "${props.country}" not supported`);
  }
}

function TextContentForBrazil(): Node {
  const { localTenancy } = useControllerContext();

  if(isLocalLatamTenantCode(localTenancy)) {
    return <>
      Ao continuar você aceita os <Link href="https://www.ebanx.com/br/termos" target="_blank">termos de uso</Link> do EBANX.
    </>;
  }

  return <>
    Esta é uma compra internacional, mediante operação de câmbio, que será intermediada pelo EBANX de acordo com seus
    {'\u00A0'}
    <Link href="https://www.ebanx.com/br/termos" target="_blank">termos e condições.</Link>
    <br />
    Ao clicar em pagar, você dá ciência e aceita os termos desta transação.
  </>;
}


function TextContentForColombia(): Node {

  return <>
      Al continuar, estarás aceptando la
      {'\u00A0'}
      <Link href="https://www.ebanx.com/co/politica-de-privacidad/" target="_blank" rel="noopener noreferrer">
        política de privacidad
      </Link>
      {'\u00A0'}
      y los
      {'\u00A0'}
      <Link href="https://www.ebanx.com/co/condiciones/" target="_blank" rel="noopener noreferrer">
        términos y condiciones
      </Link>
      {'\u00A0'}
      de EBANX.
  </>;
}
